import React, { useEffect, useState } from "react";
import { Type, Plus, Trash2, Edit3, Check, X } from "lucide-react";
import { listFieldDefinitions, createFieldDefinition, updateFieldDefinition, deleteFieldDefinition } from "../../services/catalogService";

const FieldDefinitionsManager = () => {
    const [definitions, setDefinitions] = useState([]);
    const [newName, setNewName] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editingName, setEditingName] = useState("");
    const [loading, setLoading] = useState(true);

    const load = () => listFieldDefinitions().then((d) => setDefinitions(d.definitions || [])).finally(() => setLoading(false));

    useEffect(() => { load(); }, []);

    const handleCreate = async () => {
        if (!newName.trim()) return;
        await createFieldDefinition(newName.trim());
        setNewName("");
        load();
    };

    const handleUpdate = async (id) => {
        if (!editingName.trim()) return;
        await updateFieldDefinition(id, editingName.trim());
        setEditingId(null);
        load();
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this custom field? This removes it from all products.")) return;
        await deleteFieldDefinition(id);
        load();
    };

    return (
        <div className="bg-white rounded-2xl shadow-lg p-5">
            <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2"><Type size={18} className="text-purple-600" /> Custom Fields</h3>
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-4">
                <p className="text-xs font-bold text-amber-800">No need to create Supplier, Expiration Date, etc. - these are already default fields in the catalog and every report uses them.</p>
            </div>
            <p className="text-xs text-gray-400 mb-4">
                Use Custom Fields below for anything else - model number, internal ID, storage bin, or any other alphanumeric value.
            </p>

            <div className="flex gap-2 mb-4">
                <input value={newName} onChange={(e) => setNewName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleCreate()}
                    placeholder="e.g. Storage Bin" className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500" />
                <button onClick={handleCreate} className="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-600 text-white rounded-lg text-sm font-bold hover:opacity-90 transition flex items-center gap-1">
                    <Plus size={15} /> Add
                </button>
            </div>

            {loading ? <p className="text-sm text-gray-400">Loading...</p> : (
                <div className="space-y-2">
                    {definitions.map((d) => (
                        <div key={d.id} className="flex items-center gap-2 border border-gray-100 rounded-lg px-3 py-2">
                            {editingId === d.id ? (
                                <>
                                    <input value={editingName} onChange={(e) => setEditingName(e.target.value)}
                                        className="flex-1 border border-gray-200 rounded-lg px-2 py-1 text-sm" autoFocus />
                                    <button onClick={() => handleUpdate(d.id)} className="text-green-600"><Check size={16} /></button>
                                    <button onClick={() => setEditingId(null)} className="text-gray-400"><X size={16} /></button>
                                </>
                            ) : (
                                <>
                                    <span className="flex-1 text-sm font-medium text-gray-700">{d.name}</span>
                                    <button onClick={() => { setEditingId(d.id); setEditingName(d.name); }} className="text-gray-400 hover:text-teal-600"><Edit3 size={14} /></button>
                                    <button onClick={() => handleDelete(d.id)} className="text-gray-400 hover:text-red-500"><Trash2 size={14} /></button>
                                </>
                            )}
                        </div>
                    ))}
                    {definitions.length === 0 && <p className="text-sm text-gray-400 text-center py-4">No custom fields yet.</p>}
                </div>
            )}
        </div>
    );
};

export default FieldDefinitionsManager;